module.exports = {"buildDate":"22 May 2026","buildNumber":33,"version":"1.0.0"}


//////////////////
// WEBPACK FOOTER
// ./src/build-info.json
// module id = 1780
// module chunks = 2